import {Table} from "antd";
import React, {useEffect, useState} from "react";

export const VirtualTable = ({columns, data, onLoadMore, onChange}) => {

    const handleOnScroll = e => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

        if (isAtBottom) {
            onLoadMore();
        }
    }

    const [scrollY, setScrollY] = useState(400); // default

    useEffect(() => {
        const updateHeight = () => {
            const headerOffset = 120; // adjust based on your layout
            const height = window.innerHeight - headerOffset;
            setScrollY(height);
        };

        updateHeight(); // set initial
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, [columns]);

    console.log("VirtualTable columns", columns);

    return <Table
        bordered={false}
        virtual
        columns={columns}
        scroll={{ x: 2000, y: scrollY }}
        size="small"
        dataSource={data}
        pagination={false}
        onScroll={handleOnScroll}
        onChange={onChange}
    />

}